import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-toolbox/lib/button';
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'
import ProgressBar from 'react-toolbox/lib/progress_bar'

import styles from './styles.scss'

const ButtonComponent = ({ onClick, label, icon }) => (
  <Button
    primary
    raised
    theme={styles}
  >
    <Flex flex justify='center' align='center'>
      <ProgressBar theme={styles} type='circular'/>
    </Flex>
  </Button>
)

export default ButtonComponent
